var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded"},[_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"text animate__animated animate__fadeInRight animate__slow"},[_vm._v(" Match Terminé "),_c('br'),_vm._v(" "+_vm._s(_vm.teamNameA)+" "),_c('br'),_vm._v(" VS "+_vm._s(_vm.teamNameB)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }